import * as i0 from "@angular/core";
export class ResetPasswordHomeStore {
}
ResetPasswordHomeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResetPasswordHomeStore_Factory() { return new ResetPasswordHomeStore(); }, token: ResetPasswordHomeStore, providedIn: "root" });
export var ResetPasswordHomeStoreKeys;
(function (ResetPasswordHomeStoreKeys) {
})(ResetPasswordHomeStoreKeys || (ResetPasswordHomeStoreKeys = {}));
